<template>
  <div>
    <table class="achievements mt-3">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Member</th>
        <th scope="col">Designation</th>
        <th scope="col" v-if="showPhotos">Photo</th>
      </tr>
      </thead>
      <tbody>
      <tr class="text-justify" v-for="(member,index) in members"
          :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ member.name }}</td>
        <td>{{ member.designation }}</td>
        <td v-if="member.photo">
          <img
              class="w-5 sm:w-auto object-fill rounded-lg transition duration-500 ease-in-out transform  hover:scale-105"
              :src="member.photo" alt="member">
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
export default {
  name: "CommitteeComponent",
  props: {
    members: Array,
    showPhotos: Boolean
  }
}
</script>

<style scoped>

</style>